<template>
    <section class="infobox">
        <modal v-if="modalContent" @modal-onclose="modalContent=null" :img_url="modalContent" />
        <div class="info">
          <p class="info-caption">Власник:</p>
          <p class="info-value">
            {{p.distributorName}}
          </p>
          
          <template v-if="p.distributorIdentifier">
            <p class="info-caption">Детальніше:</p>
            <p class="info-value">
              <a 
                  :href="`https://opendatabot.ua/c/${ p.distributorIdentifier }`" 
                  title="Дивитись інформацію про підприємство у opendatabot"
                  target="_blank"
              >
                {{p.distributorIdentifier}}
              </a>
            </p>
          </template>  
        </div>

        <div class="info">
          <p class="info-caption">Місце розташування:</p>
          <p class="info-value">
            {{p.addressThoroughfare}}	{{ p.addressLocatorDesignator }}
          </p>
          <p class="info-value additional" v-if="p.addressDescription">{{ p.addressDescription }}</p>
        </div>

        <div class="info">
          <p class="info-caption">Статус:</p>
          <p class="info-value">{{p.status}}</p>
          <p class="info-caption">Строк дії:</p>
          <p class="info-value">{{p.validThrough}}</p>
        </div>

        <div class="info">
          <p class="info-caption">Тип:</p>
          <p class="info-value">{{p.type}}</p>
          <p class="info-caption">Площа:</p>
          <p class="info-value">{{p.squareValue}} м²</p>
        </div>

        <div class="info">
          <p class="info-caption">Фото:</p>
          <p class="info-image-preview" v-if="p.imageURL">
            <img :src="local_image(p.imageURL)" @click="modalContent=local_image(p.imageURL)"/>
          </p>

          <p v-else><i>[відсутнє]</i></p>
        </div>    
    </section>    
</template>

<script>
import Modal from '../Modal'
import * as d3 from 'd3'
const time_format =  d3.timeFormat("%Y-%m-%d")

export default {
    name: "info-box",
    props: ["d", "entity_index"],

    components: {
      Modal
    },
    
    data() {
      return {
        modalContent: null,
      }
    },

    computed: {
      p() {
        return this.d.properties
      },
    },
    
    methods: {
      format_date(v) {
        return time_format(v);
      }, 

      local_image(url) {
        let filename = url.replace('http://slavrada.gov.ua/reklama/', '')
        return `./data/a_images/${filename}`
      }
    }
}
</script>

<style lang="scss" scoped>

.infobox {
  line-height: 1.3em;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-column-gap: 2em;
  grid-row-gap: 4em;

  .active {
    color: var(--col-active);
  }
  
  .inactive {
    color: var(--col-inactive);
  }

 .info {
    border-top: 1px solid black;
  }

  a {
    border-bottom: 2px dotted;
    &:hover {
      background-color: #E7EEF3;
    }

  }

  .info-caption {
    font-size: 0.7em;
    margin-bottom: 0;
  }

  .info-value {
    margin-bottom: 1em;
  
    &.additional {
      font-style: italic;
    }
  }

  .info-image-preview img {
    max-width: 100%;
    cursor: pointer;
    &:hover {
      border: 2px solid rgb(64, 201, 148);
    }
    margin-bottom: 1em;
  }

  a {
    img {
      height: 1em;
      display: inline-block;
      vertical-align: baseline;
    }
  }

}


</style>>